// removed by extract-text-webpack-plugin
module.exports = {"container":"_26dhdzA","list":"_3_HulsW"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Breadcrumbs/index.css
// module id = ./template/components/Breadcrumbs/index.css
// module chunks = client.sitechrome